<template>
  <button
    type="button"
    class="w-full px-3 py-2 text-left text-sm hover:bg-base-200 disabled:cursor-not-allowed disabled:opacity-50"
    :disabled="!process?.pid"
    @click="open_inject_screen"
  >
    <i class="fa-solid fa-syringe mr-2 opacity-70" aria-hidden="true"></i>
    Inject
  </button>
</template>

<script setup lang="ts">
import { router } from "@/router/router";
import type { process as ProcessType } from ".";

const props = defineProps<{
  process?: ProcessType;
}>();

const open_inject_screen = () => {
  if (!props.process?.pid) return;

  router.push({
    name: "ClientInjectCreate",
    params: { client_id: router.currentRoute.value.params.client_id },
    query: { pid: props.process.pid },
  });
};
</script>
